import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PromocodeBatchForm } from "../PromocodeBatchForm";
import { EditPromocodeBatchModalProps } from "./types";
import { useEditPromocodeModal } from "./controller";

export const EditPromocodeBatchModal = React.memo(({ modalRef, onComplete }: EditPromocodeBatchModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditPromocodeModal({
    modalRef,
    onComplete,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("promocode_batch_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <PromocodeBatchForm />
    </Modal>
  );
});
